import React from "react";

const EventComponent = ({ event, onClick, isSelected }) => {
  return (
    <div
      className={`cursor-pointer rounded w-[28px] lg:w-[100px]  overflow-hidden truncate block ${isSelected ? "bg-red-500 text-white" : "bg-blue-600 text-white"}`}
      onClick={() => onClick(event)}
      title={event.name + " - " + event.startTimeUTC}
    >
      <strong>{event.name}</strong> - {event.startTimeUTC}
    </div>
  );
};

export default EventComponent;
